import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useBlockLayout, useTable } from "react-table";
import { useSticky } from "react-table-sticky";
import ScrollShadowProvider from "src/components/ScrollShadowProvider";
import { isMobilePath } from "src/utils";

interface Props {
  data?: Array<any>;
  columns: Array<any>;
  className?: string;
  ScrollShadowProviderClassName?: string; // 모달에서 테이블을 표시할 경우 추가 클래스 적용
  isShowScrollShadow?: boolean; // 스크롤 그림자 표시 여부
  baseTableTdClassName?: string; // 테이블 셀 클래스 추가
  [key: string]: any;
}

// abstract-modal 내부에서 테이블을 가로로 긴 테이블을 사용할 경우 아래의 프롭스를 추가해주세요(그림자 효과 사라짐 & 헤더 상단 고정)
// ScrollShadowProviderClassName="overflow-visible"
// className="overflow-visible"
// isShowScrollShadow={false}

const SpaceBaseTable = ({ data, columns, className, ScrollShadowProviderClassName, isShowScrollShadow, baseTableTdClassName, ...props }: Props) => {
  const tableRef = useRef<HTMLDivElement>(null);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable(
    {
      columns: columns,
      data: data ?? [],
      ...props,
    },
    useBlockLayout,
    useSticky,
  );

  const location = useLocation();

  return (
    <ScrollShadowProvider
      tableRef={tableRef}
      isShowScrollShadow={isShowScrollShadow}
      className={`position-relative z-index-1 ${ScrollShadowProviderClassName}`}
    >
      {/* 테이블 내부에 샐랙터 오픈시 UI 짤림현상으로 position-relative z-index-1 스타일 추가 */}
      {/* 추가된 공간 테이블 */}
      <div ref={tableRef} {...getTableProps()} className={`base-table sticky  ${className ? className : ""}`}>
        <div className="header">
          {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
              {headerGroup.headers.map((header) => {
                return (
                  <div {...header.getHeaderProps()} className="base-table__th">
                    {header.render("Header")}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div {...getTableBodyProps()} className="body" style={{ maxHeight: 500 }}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <div {...row.getRowProps()} className={`base-table__tr`}>
                {row.cells.map((cell) => {
                  return (
                    <div {...cell.getCellProps()} className={`base-table__td product_table_td ${baseTableTdClassName}`}>
                      {cell.render("Cell")}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        {isMobilePath(location.pathname) && rows.length === 0 && (
          <div className="base-table__tr table-cursor-unset" {...headerGroups?.[0]?.getHeaderGroupProps()}>
            <div className="base-table__td mobile-table-no-data">
              <p>등록된 데이터가 없습니다.</p>
            </div>
          </div>
        )}
        {!isMobilePath(location.pathname) && rows.length === 0 && (
          <div className="base-table__tr table-cursor-unset" {...headerGroups?.[0]?.getHeaderGroupProps()}>
            <div className="base-table__td w-100 text-center">
              <div className="w-100 table-no-data">
                <p>등록된 데이터가 없습니다.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </ScrollShadowProvider>
  );
};

export default SpaceBaseTable;
